export var AppointmentSeriesStatus;
(function (AppointmentSeriesStatus) {
    AppointmentSeriesStatus["ACTIVE"] = "ACTIVE";
    AppointmentSeriesStatus["CANCELLED"] = "CANCELLED";
})(AppointmentSeriesStatus || (AppointmentSeriesStatus = {}));
//# sourceMappingURL=appointment-series-status.enum.js.map